module.exports = __webpack_public_path__ + "static/media/hex_citadel.1aacbdf3.png";